// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';

import ExamRecordCardMark from '../../../assets/images/exam-record-card-mark.svg';
import ExamRecordECVMark from '../../../assets/images/exam-record-ECV-mark.svg';

const S = {
  ExamPopRecordCard: styled.div`
    background: #FFFFFF;
    border-radius: 14px;
    opacity: 0.9;
    filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.21));
  `,
  ExamPopRecordCardContainer: styled.div`
    padding: 20px 130px 0;
    overflow: hidden;
    position: relative;
    z-index: 999;
  `,
  ExamPopRecordTitle: styled.p<{ status: string }>`
    font-weight: 900;
    font-size: 48px;
    ${props => props.status === 'Complete_no_pass' ? `
    font-size: 42px;
    font-weight: 600;
    color: #7D7D7D;
    `: `
    background: linear-gradient(176deg,#FAA641 0%,#FFBC6B 36.14%,#DD7800 43.15%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    `}
    line-height: normal;
  `,
  ExamPopRecordSubTitle: styled.p<{ status: string }>`
    color: #7D7D7D;
    font-weight: 700;
    font-size: 26px;
    ${props => props.status === 'Complete_no_pass' ? 'padding-bottom: 39px;' : '' }
  `,
  ExamScoreList: styled.ul`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-top: 40px;
    position: relative;
    z-index: 99;
  `,
  ExamScoreListItemScore: styled.p<{ status: string }>`
    ${props => props.status === 'Complete_no_pass' ? `
    background-color: #7D7D7D;
    `: `
    background: linear-gradient(163deg,#FAA641 0%,#FFBC6B 33.14%,#DD7800 43.15%);
    `}
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 700;
    font-size: 88px;
    line-height: 60px;
  `,
  ExamScoreListItemScoreSpan: styled.span<{ status: string }>`
    ${props => props.status === 'Complete_no_pass' ? `
    background-color: #7D7D7D;
    `: `
    background: linear-gradient(163deg,#FAA641 0%,#FFBC6B 33.14%,#DD7800 43.15%);
    `}
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 700;
    font-size: 28px;
    margin-left: 5px;
  `,
  ExamScoreListItem: styled.li`
    color: #7D7D7D;
    font-weight: 700;
    font-size: 62px;
    line-height: 60px;
  `,
  ExamScoreListItemSpan: styled.span`
    color: #7D7D7D;
    font-weight: 700;
    font-size: 28px;
    margin-left: 5px;
  `,
  ExamPopRecordFooter: styled.div`
    background: #E7E7E7;
    border-radius: 0px 0px 14px 14px;
    width: 100%;
    height: 20px;
  `,
  Examtrapezoid: styled.img.attrs({src: ExamRecordCardMark})`
    position: absolute;
    width: 100px;
    top: -12px;
    left: -16px;
  `,
  ExamRecordECVMark: styled.img.attrs({src: ExamRecordECVMark})<{ show: number }>`
    position: absolute;
    width: 450px;
    top: -155px;
    right: -25px;
    transform: rotate(${props => props.show}deg);
  `,
  ExamRecordTabContainer: styled.div`
    background: #E7E7E7;
    border-radius: 0px 0px 14px 14px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  `,
  ExamRecordTab: styled.p<{ focus:boolean }>`
    background: #E7E7E7;
    padding: 0px 20px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: #DD7800;
    }
    ${props => props.focus ? `
    background: #FFF;` : null}
  `,
}

const ExamRecordCard = (props: any): JSX.Element => {
  const scoreList = props.scoreList;
  const random = Math.floor(Math.random() * 200);

  const ResultCard = (props: any) => {
    const status = props.status;
    const scoreListItem = props.scoreListItem;

    return (
      <>
        { status === 'Complete_pass' ? <S.Examtrapezoid /> : null }
        <S.ExamPopRecordCardContainer>
          { status === 'Complete_pass' ? (
            <>
              <S.ExamPopRecordTitle status={status}>Congratulations!</S.ExamPopRecordTitle>
              <S.ExamPopRecordSubTitle status={status}>on completing the question test !<br />Here is your result </S.ExamPopRecordSubTitle>
            </>
          ) : (
            status === 'Complete_no_pass' ? (
              <>
                <S.ExamPopRecordTitle status={status}>Failed to pass the exam</S.ExamPopRecordTitle>
                <S.ExamPopRecordSubTitle status={status}>Here is your result </S.ExamPopRecordSubTitle>
              </>
            ) : (
              scoreListItem.correctNumber + scoreListItem.wrongNumber === 0 ? (
                <>
                  <S.ExamPopRecordTitle status={status}>You have complete the exam!</S.ExamPopRecordTitle>
                  <S.ExamPopRecordSubTitle status={status}>
                    But the Q&A part is need be reviewed.<br/>
                    You can go to home page to view the status.<br />
                  </S.ExamPopRecordSubTitle>
                </>
              ) : (
                <>
                  <S.ExamPopRecordTitle status={status}>You have complete the exam!</S.ExamPopRecordTitle>
                  <S.ExamPopRecordSubTitle status={status}>
                    But the Q&A part is need be reviewed.<br/>
                    You can go to home page to view the status.<br />
                    And here is your multi select result.
                  </S.ExamPopRecordSubTitle>
                </>
              )
            )
          ) }
          { status === 'Complete_pass' ? <S.ExamRecordECVMark show={random}/> : null }
          { scoreListItem.qnaScore >= 0 ? (
            <S.ExamScoreList>
              <S.ExamScoreListItemScore status={status}>
                {scoreListItem.score}<S.ExamScoreListItemScoreSpan status={status}>Score</S.ExamScoreListItemScoreSpan>
              </S.ExamScoreListItemScore>
              <S.ExamScoreListItem>
                {scoreListItem.selectScore}<S.ExamScoreListItemSpan>Multi Select</S.ExamScoreListItemSpan>
              </S.ExamScoreListItem>
              <S.ExamScoreListItem>
                {scoreListItem.qnaScore}<S.ExamScoreListItemSpan>Q&A</S.ExamScoreListItemSpan>
              </S.ExamScoreListItem>
            </S.ExamScoreList>
          ) : (
            scoreListItem.correctNumber + scoreListItem.wrongNumber === 0 ? (
              <S.ExamScoreList></S.ExamScoreList>
            ) : (
              <S.ExamScoreList>
                <S.ExamScoreListItemScore status={status}>
                  {scoreListItem.score}<S.ExamScoreListItemScoreSpan status={status}>Score</S.ExamScoreListItemScoreSpan>
                </S.ExamScoreListItemScore>
                <S.ExamScoreListItem>
                  {scoreListItem.correctNumber}<S.ExamScoreListItemSpan>Correct</S.ExamScoreListItemSpan>
                </S.ExamScoreListItem>
                <S.ExamScoreListItem>
                  {scoreListItem.wrongNumber}<S.ExamScoreListItemSpan>Wrong</S.ExamScoreListItemSpan>
                </S.ExamScoreListItem>
              </S.ExamScoreList>
            )
          )}
        </S.ExamPopRecordCardContainer>
      </>
    )
  }

  return (
    <S.ExamPopRecordCard>
      <ResultCard status={scoreList.status} scoreListItem={scoreList}/>
      <S.ExamPopRecordFooter />
    </S.ExamPopRecordCard>
  )
}

export { ExamRecordCard as default };
